import axios from 'axios';
import { GET_BIO } from './types';
import { API_HOST } from '../vars';

export const getBio = () => dispatch => {
    axios
        .get(`${API_HOST}/bio/get`)
        .then(({ data: { section, page, data } }) => {
            dispatch({
                type: GET_BIO,
                payload: {
                    loaded: true,
                    section,
                    page,
                    data
                }
            });
        })
        .catch(error => console.log(error));
};
